// Chakra Icons
import { BellIcon, SearchIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Button,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  Avatar,
  HStack,
  VStack,
} from "@chakra-ui/react";
// Custom Icons
import { ProfileIcon, SettingsIcon } from "../Icons/Icons";
// Custom Components
import { ItemContent } from "../Menu/ItemContent";
import SidebarResponsive from "../Sidebar/SidebarResponsive";
import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
import routes from "../../routes.js";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContext";

export default function HeaderLinks(props) {
  const { variant, children, fixed, secondary, onOpen, ...rest } = props;
  const { user, logout, isAuthenticated } = useAuth();

  // Chakra Color Mode
  let mainTeal = useColorModeValue("teal.300", "teal.300");
  let inputBg = useColorModeValue("white", "gray.800");
  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  let searchIcon = useColorModeValue("gray.700", "gray.200");

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
  const settingsRef = React.useRef();
  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
    >
     
      {isAuthenticated ? (
        <Menu>
          <MenuList p="16px 8px">
            <Flex flexDirection="column">
              {/* نمایش اطلاعات کاربر */}
              <Flex 
                p="12px 16px" 
                borderBottom="1px solid" 
                borderColor="gray.200"
                mb="8px"
              >
                <VStack spacing={1} align="start">
                  <Text fontWeight="bold" fontSize="sm">
                    {user?.name || 'کاربر'}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    {user?.role === 'admin' ? 'مدیر' : 
                     user?.role === 'consultant' ? 'مشاور' : 
                     user?.role || 'کاربر'}
                  </Text>
                </VStack>
              </Flex>
              
              
              <MenuItem 
                borderRadius="8px"
                onClick={logout}
                icon={<FaSignOutAlt />}
                color="red.500"
                _hover={{ bg: "red.50" }}
              >
                <Text>خروج از سیستم</Text>
              </MenuItem>
            </Flex>
          </MenuList>
          <MenuButton
            as={Button}
            ms="0px"
            px="0px"
            me={{ sm: "2px", md: "16px" }}
            color={navbarIcon}
            variant="transparent-with-icon"
            rightIcon={
              document.documentElement.dir ? (
                ""
              ) : (
                <FaUser color={navbarIcon} size="18px" />
              )
            }
            leftIcon={
              document.documentElement.dir ? (
                <FaUser color={navbarIcon} size="18px" />
              ) : (
                ""
              )
            }
          >
            <HStack spacing={2} display={{ sm: "none", md: "flex" }}>
              <Avatar size="sm" name={user?.name || 'کاربر'} bg="teal.500" />
              <Text>{user?.name || 'کاربر'}</Text>
            </HStack>
          </MenuButton>
          
        </Menu>
      ) : (
        <NavLink to="/auth/signin">
          <Button
            ms="0px"
            px="0px"
            me={{ sm: "2px", md: "16px" }}
            color={navbarIcon}
            variant="transparent-with-icon"
            rightIcon={
              document.documentElement.dir ? (
                ""
              ) : (
                <ProfileIcon color={navbarIcon} w="22px" h="22px" me="0px" />
              )
            }
            leftIcon={
              document.documentElement.dir ? (
                <ProfileIcon color={navbarIcon} w="22px" h="22px" me="0px" />
              ) : (
                ""
              )
            }
          >
            <Text display={{ sm: "none", md: "flex" }}>ورود</Text>
          </Button>
        </NavLink>
      )}
      <SidebarResponsive
        logoText={props.logoText}
        secondary={props.secondary}
        routes={routes}
        // logo={logo}
        {...rest}
      />
      {isAuthenticated && (
        <IconButton
          ms={{ base: "8px", xl: "0px" }}
          me="8px"
          color={navbarIcon}
          variant="transparent-with-icon"
          icon={<FaSignOutAlt size="16px" />}
          onClick={logout}
          title="خروج از سیستم"
          _hover={{ color: "red.500" }}
        />
      )}
      <SettingsIcon
        cursor="pointer"
        ms={{ base: "16px", xl: "0px" }}
        me="16px"
        ref={settingsRef}
        onClick={props.onOpen}
        color={navbarIcon}
        w="18px"
        h="18px"
      />
      <Menu>
        <MenuButton>
          <BellIcon color={navbarIcon} w="18px" h="18px" />
        </MenuButton>
        <MenuList p="16px 8px">
          <Flex flexDirection="column">
            <MenuItem borderRadius="8px" mb="10px">
              <ItemContent
                time="13 دقیقه پیش"
                info="از علی"
                boldInfo="پیام جدید"
                aName="علی"
                aSrc=""
              />
            </MenuItem>
            <MenuItem borderRadius="8px" mb="10px">
              <ItemContent
                time="2 روز پیش"
                info="از احمد"
                boldInfo="ملاقات جدید"
                aName="احمد"
                aSrc=""
              />
            </MenuItem>
            <MenuItem borderRadius="8px">
              <ItemContent
                time="3 روز پیش"
                info="پرداخت با موفقیت انجام شد!"
                boldInfo=""
                aName="سارا"
                aSrc=""
              />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
